import { join } from 'lodash';
import { AMLS_MODULES_AND_ALERT_SOURCE_MAPPING } from './GlobalConstant';

export const getAlertColorCode = (level) => {
  let color = '';
  if (level) {
    if (level.toLowerCase() === 'high') color = '#DF6057';
    // red
    else if (level.toLowerCase() === 'good') color = '#E29840';
    // orange
    else color = '#71C969'; // green
  }
  return color;
};

export const getAttributeByResourceCode = (authentication, resourceCode) => {
  let obj = authentication?.data?.filter((item) =>
    item?.details?.resource?.operations?.includes(resourceCode)
  );
  if (obj?.length > 0) {
    obj = obj[0].attributes.filter(
      (o) => o.attributeKey === 'PRODUCT_SOURCE_ID'
    )[0];
    return join(obj.attributeValues, ',');
  } else return '';
};

export const getModuleTypeByResourceCode = (authentication, resourceCode) => {
  let ar = [];

  let attributes = getAttributeByResourceCode(authentication, resourceCode);

  attributes = attributes.split(',');
  attributes?.map((sourceId) => {
    let filteredModule = AMLS_MODULES_AND_ALERT_SOURCE_MAPPING.filter(
      (item) => item.value == sourceId
    );
    if (filteredModule.length > 0) ar.push(...filteredModule);
  });

  return ar;
};

export const displaySwitchForTSNS = (authentication, alertResourceCode) => {
  return (
    getAttributeByResourceCode(authentication, alertResourceCode) == '7' ||
    getAttributeByResourceCode(authentication, alertResourceCode) == '9' ||
    getAttributeByResourceCode(authentication, alertResourceCode) == '7,9'
  );
};

export const skipWatchlistAndWhitelistForRiskScoring = (
  authentication,
  alertResourceCode
) => {
  return getAttributeByResourceCode(authentication, alertResourceCode) == '17';
};

export const renderBooleanValue = (value) => {
  if (value === undefined) return '--';
  if (typeof value === 'boolean') {
    return value.toString().charAt(0).toUpperCase() + value.toString().slice(1);
  }
  return value;
};
